import { render, staticRenderFns } from "./emptyCompetences.vue?vue&type=template&id=5d185acf&scoped=true&"
import script from "./emptyCompetences.vue?vue&type=script&lang=js&"
export * from "./emptyCompetences.vue?vue&type=script&lang=js&"
import style0 from "./emptyCompetences.vue?vue&type=style&index=0&id=5d185acf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d185acf",
  null
  
)

export default component.exports